import { ActionType } from '../action-types/index'
import { Action } from '../actions/index'
import { UserRole } from "../../models"

const initialState: UserRole = UserRole.NotSet

const reducer = (state: string = initialState, action: Action) => {
    switch (action.type) {
        case ActionType.UpdateRole:
            return state = action.payload
        default:
            return state
    }
}

export default reducer